import { render } from "./VosQualityRecord.vue?vue&type=template&id=05b24a80&scoped=true"
import script from "./VosQualityRecord.vue?vue&type=script&lang=js"
export * from "./VosQualityRecord.vue?vue&type=script&lang=js"

import "./VosQualityRecord.vue?vue&type=style&index=0&id=05b24a80&lang=scss&scoped=true"
import "./VosQualityRecord.vue?vue&type=style&index=1&id=05b24a80&lang=scss"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b24a80"]])

export default __exports__